import { httpOk, GET } from 'helpers/api'

// Позиции для акций — всё, что продаётся из меню: и «Продукты», и «Элементы»
// (напитки, хлеб, соусы). /helper/products отдаёт только in_product = 1 и теряет элементы.
export async function getMenuProducts(settings = {}) {
	const response = await GET('/helper/menu-products', {}, settings)
	if (!httpOk(response)) return []

	const result = []
	const seen = new Set()
	function walk(menus) {
		for (const menu of menus ?? []) {
			for (const product of menu.products ?? []) {
				if (seen.has(product.id)) continue
				seen.add(product.id)
				result.push({ id: product.id, name: product.name })
			}
			walk(menu.children)
		}
	}
	walk(response.data?.data)
	return result
}
